import React from 'react'
import TabsSimple from '~/Common-Objects/Tabs/TabsSimple'
import Icons from '~/Common-Objects/UI/Icons'

const DeviceToggle = ({ device, setDevice, showTablet }) => {
    const devices = [
        {
            label: 'Desktop',
            icon: 'monitor',
            value: 0
        },
        ...(showTablet
            ? [
                  {
                      label: 'Tablet',
                      icon: 'tabletOutline',
                      value: 2
                  }
              ]
            : []),
        {
            label: 'Mobile',
            icon: 'mobileOutline',
            value: 1
        }
    ]

    return (
        <TabsSimple
            dataAttributes={{
                'onboarding-enabled': true,
                'onboarding-id': 'dragdrop_mobile_desktop_toggle'
            }}
            tabs={devices.map((theDevice) => ({
                label: (
                    <>
                        <Icons icon={theDevice.icon} color='#525150' className='mar-r5' style={{ height: '25px' }} />
                        <span>{theDevice.label}</span>
                    </>
                ),
                value: theDevice.value
            }))}
            selectedTab={device}
            onChange={(tab) => {
                setDevice(tab)
            }}
        />
    )
}

export default DeviceToggle
